import { createSlice } from '@reduxjs/toolkit';
import { logoutAction } from 'features/common/commonSlice';
import { getHeaderColorsAsync, getHeaderLogoAsync } from './asyncActions';

export interface GroupLogoState {
  /** URL del logo de la cabecera. null = aún no resuelta: la cabecera pinta el de TMC. */
  headerUrl: string | null;
  /** Colores de marca del grupo del usuario. null = aún no resueltos: mandan los de TMC del CSS. */
  brandColors: { primary: string; secondary: string } | null;
}

const initialState: GroupLogoState = {
  headerUrl: null,
  brandColors: null,
};

export const groupLogoSlice = createSlice({
  name: 'groupLogo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHeaderLogoAsync.fulfilled, (state, action) => {
        state.headerUrl = action.payload?.url ?? null;
      })
      .addCase(getHeaderColorsAsync.fulfilled, (state, action) => {
        const item = action.payload;
        state.brandColors = item ? { primary: item.primaryColor, secondary: item.secondaryColor } : null;
      })
      // Si falla se queda el que hubiera: mejor un logo algo desfasado que ninguno.
      // Al salir sí se limpia, o el siguiente usuario vería el logo del anterior hasta resolver el suyo.
      .addCase(logoutAction, (state) => {
        state.headerUrl = null;
        state.brandColors = null;
      });
  },
});

export default groupLogoSlice.reducer;
